import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

// Searchable select with "create if not found" support.
// New items use value "new|Name" so the backend can create the record.
export default class extends Controller {
  static values = {
    createFilter: { type: Number, default: 2 },
    placeholder: { type: String, default: "" },
  }

  connect() {
    const options = {
      allowEmptyOption: true,
      create: (input) => {
        const trimmed = input?.trim() || ""
        if (trimmed.length < this.createFilterValue) return null
        return { value: `new|${trimmed}`, text: trimmed }
      },
      createFilter: (input) => (input?.trim()?.length || 0) >= this.createFilterValue,
      render: {
        option_create: (data, escape) =>
          `<div class="create">Choisir <strong>${escape(data.input)}</strong>&hellip;</div>`,
        no_results: (data, escape) =>
          `<div class="no-results"></div>`,
      },
    }

    if (this.placeholderValue) {
      options.placeholder = this.placeholderValue
    }

    this.tomSelect = new TomSelect(this.element, options)
  }

  disconnect() {
    if (this.tomSelect) {
      this.tomSelect.destroy()
    }
  }
}
